module.exports = __webpack_public_path__ + "img/ln.d5f82986.png";